import { BREAKPOINT_DIMENSIONS } from "@quickenloans-ui-suite/design-system";
import { RIBBON_CLASS, GLOBAL_HEADER_CLASS, BACKDROP_CLASS, NO_SCROLL_CLASS } from "./constants/index.es.js";
const classes = {
  [GLOBAL_HEADER_CLASS]: {
    // Dimensions should be updated to match latest changes of the design system
    padding: {
      mobile: "20px 16px 24px 8px",
      [BREAKPOINT_DIMENSIONS.medium]: "20px 16px 24px 24px",
      [BREAKPOINT_DIMENSIONS.extra_large]: "20px 40px",
      [BREAKPOINT_DIMENSIONS.extra_extra_large]: "20px 40px"
    },
    nav: {
      desktop: {
        link: {
          height: 37,
          borderRadius: 5,
          gap: 8
        }
      }
    }
  },
  [RIBBON_CLASS]: {
    // Dimensions should be updated to match latest changes of the design system
    padding: {
      mobile: {
        left: "16px",
        bottom: "20px"
      },
      [BREAKPOINT_DIMENSIONS.medium]: {
        left: "16px"
      },
      [BREAKPOINT_DIMENSIONS.extra_extra_large]: "20px 40px"
    }
  },
  [BACKDROP_CLASS]: {
    color: "#33333366",
    blur: "blur(4px)"
  }
};
const components = {
  components: {
    MuiCssBaseline: {
      styleOverrides: (theme) => {
        const ribbonPadding = theme.vars[RIBBON_CLASS].padding;
        const globalHeaderPadding = theme.vars[GLOBAL_HEADER_CLASS].padding;
        const { nav } = theme.vars[GLOBAL_HEADER_CLASS];
        return {
          [`&.${GLOBAL_HEADER_CLASS}`]: {
            padding: globalHeaderPadding.mobile,
            [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.medium)]: {
              padding: globalHeaderPadding[BREAKPOINT_DIMENSIONS.medium]
            },
            [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_large)]: {
              padding: globalHeaderPadding[BREAKPOINT_DIMENSIONS.extra_large]
            },
            [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_extra_large)]: {
              padding: globalHeaderPadding[BREAKPOINT_DIMENSIONS.extra_extra_large]
            },
            nav
          },
          [`&.${RIBBON_CLASS}`]: {
            paddingLeft: ribbonPadding.mobile.left,
            paddingBottom: ribbonPadding.mobile.bottom,
            [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.medium)]: {
              paddingLeft: ribbonPadding[BREAKPOINT_DIMENSIONS.medium].left
            },
            [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_large)]: {
              padding: ribbonPadding[BREAKPOINT_DIMENSIONS.extra_extra_large]
            }
          },
          [`&.${NO_SCROLL_CLASS}`]: {
            position: "fixed",
            top: "0px",
            left: "0px",
            width: "100%",
            height: "auto",
            minHeight: "100%"
          }
        };
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: ({ theme }) => {
          const { color, blur } = theme.vars[BACKDROP_CLASS];
          return {
            backgroundColor: color,
            [theme.breakpoints.down(BREAKPOINT_DIMENSIONS.extra_large)]: {
              backdropFilter: blur,
              WebkitBackdropFilter: blur
            }
          };
        }
      }
    }
  }
};
export {
  components as a,
  classes as c
};
//# sourceMappingURL=components-C0dQUxiy.js.map
